import { Account, AccountListResponse, AccountQueryParams, CreateAccount, InitializeOptions, UpdateAccount } from '@frontend/account/types';
import { APIClient, ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';

export class AccountClient extends APIClient {
    public static readonly endpoint = '/account-api/v1';

    public static async fetchAccounts(queryParams?: ApiQueryParams<DefaultQueryParams | AccountQueryParams>): Promise<AccountListResponse> {
        return await this.apiPaginated<AccountListResponse, DefaultQueryParams>(`${this.endpoint}/accounts`, queryParams);
    }

    public static async postAccount(account: CreateAccount): Promise<Account> {
        const response = await this.post(`${this.endpoint}/accounts`, account);
        return await this.handleResponse<Account>(response);
    }

    public static async resolveAccounts(ids: string[], field: string = 'id'): Promise<AccountListResponse> {
        return this.resolve<AccountListResponse>(`${this.endpoint}/accounts`, ids, field);
    }

    public static async fetchAccount(accountId: string): Promise<Account> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}`);
        return await this.handleResponse<Account>(response);
    }

    public static async patchAccount(accountId: string, account: UpdateAccount): Promise<Account> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}`, account);
        return await this.handleResponse<Account>(response);
    }

    public static async deleteAccount(accountId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}`);
        return await this.handleVoidResponse(response);
    }

    public static async deleteAccounts(accountIds: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/accounts-delete`, { ids: accountIds });
        return await this.handleVoidResponse(response);
    }

    public static async postIoTSeed(accountId: string, iotId: string, body: { account_id: string }): Promise<void> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/iots/${iotId}/seed`, body);
        return this.handleResponse(response);
    }

    public static async initializeAccount(accountId: string, options: InitializeOptions): Promise<void> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/initialize`, options);
        return await this.handleVoidResponse(response);
    }
}
